import usersRoutes from './users'
import financeRoutes from './finance'
import dashboardRoutes from './dashboard'
import technicalRoutes from './technical'
import analysisRoutes from './analysis'
import marketingRoutes from './marketing'
import settingRoutes from './settings'

const items = [
  {
    title: 'navigation.admin-dashboard',
    route: 'super:home',
    icon: 'HomeIcon',
  },
  ...usersRoutes,
  ...financeRoutes,
  ...dashboardRoutes,
  ...marketingRoutes,
  ...analysisRoutes,
  ...technicalRoutes,
  ...settingRoutes,
]

function setSuperAdmin(navItems: any) {
  if (!navItems?.length) return null

  return navItems.map((item: any) => ({ ...item, superAdmin: true, children: item.children ? setSuperAdmin(item.children) : null }))
}

export default setSuperAdmin(items)
